/** Side views of the vehicle types, by the icon name the admin gives each type. */

type Shape = { body: string; windows: string[] };

const SHAPES: Record<string, Shape> = {
  saloon: {
    body: "M5 25v-5.2c0-1.6 1-2.9 2.6-3.3l9.4-2.4 7.2-5.6c1-.8 2.3-1.2 3.6-1.2h13.4c1.4 0 2.7.5 3.7 1.4l6 5.4 6.2 1.3c1.8.4 3 1.9 3 3.7V25z",
    windows: [
      "M19.5 14.6l5.6-4.4c.6-.5 1.4-.7 2.2-.7h4.9v5.1z",
      "M34.4 9.5h6.3c.8 0 1.6.3 2.2.9l4.6 4.2H34.4z",
    ],
  },
  estate: {
    body: "M5 25v-5.2c0-1.6 1-2.9 2.6-3.3l9.4-2.4 7.2-5.6c1-.8 2.3-1.2 3.6-1.2h22.4c1.5 0 2.8.9 3.4 2.3l3.3 7c.7.4 1.1 1.1 1.1 1.9V25z",
    windows: [
      "M19.5 14.6l5.6-4.4c.6-.5 1.4-.7 2.2-.7h4.9v5.1z",
      "M34.4 9.5h8.8v5.1h-8.8z",
      "M45.2 9.5h4.3c.6 0 1.1.3 1.3.9l1.9 4.2h-7.5z",
    ],
  },
  mpv: {
    body: "M5 25v-6.2c0-1.5.9-2.8 2.3-3.3l7.7-2.9 6.8-6.3c1-.9 2.3-1.4 3.6-1.4h25.4c1.7 0 3.1 1.1 3.6 2.7l3.1 10.2c.3.4.5.9.5 1.4V25z",
    windows: [
      "M17.8 13.4l5.4-5.1c.6-.5 1.3-.8 2.1-.8h5.6v5.9z",
      "M33 7.5h8.6v5.9H33z",
      "M43.6 7.5h6.4c.8 0 1.5.5 1.7 1.3l1.3 4.6h-9.4z",
    ],
  },
  executive: {
    body: "M4 25v-4.6c0-1.5 1-2.8 2.5-3.2l10.3-2.6 7.6-5.4c1-.7 2.2-1.1 3.4-1.1h14.4c1.3 0 2.5.4 3.5 1.2l6.6 5.1 6.6 1.2c1.8.3 3.1 1.9 3.1 3.7V25z",
    windows: [
      "M20 15.1l5.8-4.2c.6-.4 1.3-.6 2-.6h5.3v4.8z",
      "M35.1 10.3h7.1c.7 0 1.4.2 2 .7l4.6 4.1H35.1z",
    ],
  },
  wheelchair: {
    body: "M5 25V12.4c0-1.4.7-2.7 1.9-3.4l5.6-3.5c.8-.5 1.7-.8 2.6-.8h38.4c2 0 3.6 1.6 3.6 3.6v8.4l2.6 1.3c1 .5 1.7 1.6 1.7 2.7V25z",
    windows: ["M9.8 13l4.7-4.6c.4-.4 1-.6 1.5-.6h4.6V13z", "M23 7.8h9v5.2h-9z"],
  },
};

export function VehicleArt({ icon, size = 64 }: { icon: string; size?: number }) {
  const shape = SHAPES[icon] ?? SHAPES.saloon!;
  return (
    <svg
      width={size}
      height={size / 2}
      viewBox="0 0 64 32"
      aria-hidden="true"
      className="vehicle-art"
    >
      <ellipse cx="33" cy="28.6" rx="28" ry="1.6" fill="currentColor" opacity="0.12" />
      <path d={shape.body} fill={icon === "executive" ? "var(--vehicle-dark)" : "var(--primary)"} />
      {shape.windows.map((d) => (
        <path key={d} d={d} fill="var(--vehicle-glass)" />
      ))}
      {icon === "wheelchair" && (
        <g fill="none" stroke="var(--vehicle-glass)" strokeWidth="1.6" strokeLinecap="round">
          <circle cx="42" cy="18" r="3.2" />
          <path d="M40.8 11.3v4.2h3.6l1.5 3.7" />
          <circle cx="40.8" cy="9.8" r=".4" />
        </g>
      )}
      {[16, 49].map((cx) => (
        <g key={cx}>
          <circle cx={cx} cy="25" r="5" fill="var(--vehicle-tyre)" />
          <circle cx={cx} cy="25" r="2" fill="var(--vehicle-hub)" />
        </g>
      ))}
    </svg>
  );
}
